import 'zone.js';

(globalThis as any).global = globalThis;
